import { render, staticRenderFns } from "./trip.vue?vue&type=template&id=4a1c894a&scoped=true&"
import script from "./trip.vue?vue&type=script&lang=js&"
export * from "./trip.vue?vue&type=script&lang=js&"
import style0 from "./trip.vue?vue&type=style&index=0&id=4a1c894a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c894a",
  null
  
)

export default component.exports